<template>
   <v-dialog v-model="dialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">Tần suất gửi dữ liệu</v-card-title>
        <v-card-text>
          <v-radio-group v-model="radios" :mandatory="false" class="mt-0 pt-0">
            <v-radio label="Mặc định 15 phút/lần" color="blue darken-2" value="default"></v-radio>
            <v-radio label="Tùy chỉnh" color="blue darken-2" value="custom"></v-radio>
          </v-radio-group>
          <div v-if="radios === 'custom'" class="px-2">
            <v-slider
              class="slider-interval"
              v-model="sliderInterval"
              min="1"
              max="120"
              @change="changeSlideInterval"
              prepend-icon="1"
              append-icon="120"
            >
            </v-slider>
            <p class="text-xs-center display-1">{{sliderInterval}} phút</p>
            <p class="text-xs-center"> Lưu ý, tần suất gửi dữ liệu càng thấp thì thiết bị sẽ tiêu thụ càng nhiều điện năng</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat="flat" @click.native="close()">Hủy</v-btn>
          <v-btn color="primary darken-1" flat="flat" :loading="loadingBtn" @click.native="setTntervalSendData">Cập nhật</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    dialog: false,
    radios: 'default',
    sliderInterval: 60,
    dataVehicle: null,
    loadingBtn: false
  }),

  computed: {
    ...mapGetters(['selectedVehicle'])
  },

  methods: {
    ...mapActions(['intervalSendData', 'getVehicles']),

    open (selectedVehicle) {
      this.dataVehicle = selectedVehicle;
      if (this.dataVehicle.interval) {
        this.radios = 'custom';
        this.sliderInterval = Math.ceil(this.selectedVehicle.interval / 60);
      }
      this.dialog = true;
    },

    close () {
      this.dialog = false;
      this.reset();
    },

    changeSlideInterval () {
      console.log('changeSlideInterval -> val', this.sliderInterval);
    },

    reset () {
      this.radios = 'default';
      this.sliderInterval = 60;
    },

    async setTntervalSendData () {
      let interval = 15;
      if (this.radios === 'custom') interval = this.sliderInterval;

      let data = {
        interval: interval * 60,
        vehicleId: this.dataVehicle.id
      };

      this.loadingBtn = true;
      let res = await this.intervalSendData(data).catch(_ => {
        return null;
      });

      this.loadingBtn = false;

      if (!res) {
        window.getApp.showMessage('Thiết lập tần suất gửi dữ liệu thất bại', 'error');
        return;
      }

      window.getApp.showMessage('Thiết lập tần suất gửi dữ liệu thành công', 'success');
      this.selectedVehicle.interval = interval * 60;
      this.getVehicles();
      this.close();
    }

  }
};
</script>

<style scoped>
.slider-interval >>>.v-input__append-outer {
    margin-left: 15px;
}
.slider-interval >>> .v-input__prepend-outer .v-icon, .slider-interval >>> .v-input__append-outer .v-icon{
  font-family: inherit;
  font-size: 16px;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/IntervalSendData.vue